import { Button } from "@/components/Button"
import { copyToClipboard, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"

export const GetVerificationLink = () => {
  const { iban_kyc_url } = useStoreClient(selectUser)
  return (
    <div className="aplication-form__row d-flex flex-column justify-content-between">
      <h4 className="h4 application-form__upload-title uppercase">
        <FormattedMessage id={`get_verification_link`} />
      </h4>
      <p>
        <FormattedMessage id="get_link_desc" />
      </p>
      <div className="d-flex mt-4">
        <input type="text" className="w-full input mr-0" value={iban_kyc_url} onKeyDown={(e) => e.preventDefault()} />
        <Button disabled={(iban_kyc_url || "").length < 1} className="ml-[-1px]" onClick={() => copyToClipboard(iban_kyc_url!)}>
          <FormattedMessage id="copy" />
        </Button>
      </div>
    </div>
  )
}
